<template>
    <!-- ************************************************************************************** -->
    <!-- *                             PAGINATION CONTROLS                                    * -->
    <!-- ************************************************************************************** -->
    <b-row class="mb-1">
        <b-col cols="12">
            <label class="text-center d-block">
                <span class="xxxsr-only">Page {{ pollsTableCurrentPage }} of {{ pollsTableLastPage }}</span>&nbsp;
            </label>
        </b-col>
        <b-col cols="3">
            <b-form-group
                label="Polls per page"
                label-for="perPageSelect"
                label-cols="4"
                class="mb-0"
            >
                <b-form-select
                    v-model="pollsPerPage"
                    id="perPageSelect"
                    :options="pollsPerPageOptions"
                ></b-form-select>
            </b-form-group>
        </b-col>
        <b-col cols="9">
            <b-pagination
                v-model="pollsTableCurrentPage"
                :total-rows="pollsTableNumberOfPolls"
                :per-page="pollsPerPage"
                limit="7"
                align="fill"
                aria-controls="polls-table"
                first-text="« First Page"
                last-text="Last Page »"
                prev-text="‹ Previous Page"
                next-text="Next Page ›"
            ></b-pagination>
        </b-col>
    </b-row>
</template>

<script setup>
    import { onMounted, computed } from 'vue'
    import { storeToRefs } from 'pinia';

    // Stores
    import { usePollsStore } from '../../stores/polls';

    const pollsStore = usePollsStore();

    // // Store refs
    const {
        pollsTableCurrentPage,
        pollsPerPage,
        pollsPerPageOptions,
        pollsTableNumberOfPolls,
        numberOfPolls,
    } = storeToRefs(pollsStore);

    onMounted(() => {
        console.log(`TablePaginationControls Component mounted.`);
    });

    const pollsTableLastPage = computed(() => {
        return Math.ceil(numberOfPolls.value / pollsPerPage.value);
    });

</script>

<style>

</style>
